import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Set initial time to 15 minutes for urgency
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center gap-2 text-brand-pink font-bold text-xl my-4" data-id="element-242">
      <div className="flex flex-col items-center" data-id="element-243">
        <span className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-pastelpink" data-id="element-244">
          {minutes.toString().padStart(2, '0')}
        </span>
        <span className="text-[10px] uppercase mt-1 text-brand-black opacity-60" data-id="element-245">
          Min
        </span>
      </div>
      <span className="text-2xl pb-4" data-id="element-246">:</span>
      <div className="flex flex-col items-center" data-id="element-247">
        <span className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-pastelpink" data-id="element-248">
          {seconds.toString().padStart(2, '0')}
        </span>
        <span className="text-[10px] uppercase mt-1 text-brand-black opacity-60" data-id="element-249">
          Seg
        </span>
      </div>
    </div>;
}